export type EmployeeStatusLabel =
  | "Invited"
  | "Registered"
  | "Capturing"
  | "Vetted"
  | "Onboarding"
  | "Active"
  | "Offboarding"
  | "Terminated"

export type EmployeeStatusCode = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7

export type EmployeeStatusDto = EmployeeStatusLabel | EmployeeStatusCode

export const employeeStatusToCode = {
  Invited: 0,
  Registered: 1,
  Capturing: 2,
  Vetted: 3,
  Onboarding: 4,
  Active: 5,
  Offboarding: 6,
  Terminated: 7,
} as const

export function toEmployeeStatusCode(
  status: EmployeeStatusDto,
): EmployeeStatusCode {
  if (typeof status === "number") return status

  return employeeStatusToCode[status]
}

export function toEmployeeStatusLabel(
  status: EmployeeStatusDto,
): EmployeeStatusLabel {
  if (typeof status === "string") return status

  if (status === 0) return "Invited"
  if (status === 1) return "Registered"
  if (status === 2) return "Capturing"
  if (status === 3) return "Vetted"
  if (status === 4) return "Onboarding"
  if (status === 5) return "Active"
  if (status === 6) return "Offboarding"
  if (status === 7) return "Terminated"
  return "Active"
}

export interface EmployeeDto {
  id: string
  firstName: string
  lastName: string
  email: string
  jobTitle: string
  status: EmployeeStatusDto
  onboardingStatus?: string
  createdAt: string
  recruitmentApplicationId?: string | null
  inviteSent?: boolean
  hasActiveWorkflow?: boolean
}
